import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import slugify from 'underscore.string/slugify';

import Card from '../../records/payment/Card';
import { translate as t } from '../../lib/I18n';
import ValidatedFormField from '../form/ValidatedField';
import CardForm from '../../records/payment/CardForm';


function CardNumber (props) {

    const cardType = Card.getType(props.form.cardNumber);
    const cardClassNames = classnames('card-indicator', {
        [ `card-${slugify(cardType && cardType.toLowerCase())}` ]: !!cardType
    });

    return (
        <div className="card-number input-with-addon input-with-addon--right">
            <ValidatedFormField { ...props }
                type="tel"
                id="cardNumber"
                field="cardNumber"
                name="cc-number"
                label={ t('customerdetails.payment.cardnumber') }
                placeholder={ t('customerdetails.payment.cardnumber.placeholder') }
                showPlaceholder
                labelClassName="sr-only"
                autoComplete="cc-number"
            />

            <div className={ cardClassNames } />
        </div>
    );
}

CardNumber.propTypes = {
    form: PropTypes.instanceOf(CardForm).isRequired,
    ..._.pick(ValidatedFormField.propTypes, [
        'form',
        'onChange',
        'disabled',
        'required',
        'visited',
        'validation'
    ])
};

export default CardNumber;



// WEBPACK FOOTER //
// ./src/components/payment/CardNumber.js